<template>
  <div>
    <van-nav-bar
      title="协议列表"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-row class="p-r-75 p-l-75">
      <van-col
        :span="24"
        class="bg-white m-t-06"
        style="border-radius: 0.3rem; padding-bottom: 0.5rem"
        v-for="(item, index) in agreementList"
        :key="index"
        @click="goAgreementDetial(item)"
      >
        <van-row style="padding-left: 0.75rem; padding-right: 0.75rem">
          <div class="van-multi-ellipsis--l2 p-t-05">
            <span class="f-s-16" style="color: #292e35; font-weight: 600">
              {{ item.name }}
            </span>
          </div>
          <p class="f-s-6 m-t-04" style="color: #657081">
            签署时间{{ item.signTime }}
          </p>
        </van-row>
      </van-col>
    </van-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      agreementList: [],
    };
  },
  created() {
    this.getAgreementList();
  },
  methods: {
    // 去查看协议详情
    goAgreementDetial(item) {
      console.log(item)
      this.$router.push({
        path: "/agreementDetial",
        query: {
          uid: this.uid(),
          id: item.agreementid,
          cid : item.cid
        },
      });
    },
    getAgreementList() {
      let data = {
        uid: this.uid(),
      };
      this.ApiNew.Mine.agreementList(data).then((res) => {
        if (res.retuCode == 5000) {
          this.agreementList = res.data;
        } else {
          this.$toast(res.message);
        }
      });
    },
  },
};
</script>

<style scoped>
.tag {
  width: 2rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  height: 0.6rem;
  border-top-left-radius: 0.55rem;
  border-bottom-left-radius: 0.55rem;
}
.bodyTag {
  width: 1.6rem;
  height: 0.9rem;
}
</style>